import { SandboxIframe } from '#src/app/pages/startAPetitionV2/shared/components';

import { useChatAgent } from './hooks/useChatAgent';

export const ChatAgent: React.FC = () => {
	const { data } = useChatAgent();

	return <SandboxIframe src={data.iframeSrc} title="Petition Agent" />;
};
